export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: 'admin/login',
    GET_ADMIN_USER: 'super-admin/get-super-admin',
    NEW_ADMIN_USER: 'super-admin/add-super-admin',
    VERIFY_FORGET_EMAIL: 'super-admin/check-user-emailForSendOtp',
    VERIFY_FORGET_OTP: 'super-admin/verify-otp',
    RESEND_FORGET_OTP: 'super-admin/resend-otp',
    UPDATE_PASSWORD: 'super-admin/update-password',
  },
  DASHBOARD: {
    RECENT_TICKET: 'customer/getSupportTicket',
    UPDATE_TICKET_STATUS: 'customer/updateSupportTicket',
    GET_GATEWAY: 'gateway/get-gateway',
    GATEWAY_LOGS: 'device-logs',
    OFFLINE_SENSORS: 'sensor/get-offline-sensor',
    SENSOR_LOGS: 'device-logs',
    LOW_BATTERY: 'sensor/get-low-battery-sensor',
    BATTERY_REPORT: 'sensor/get-battery-report'
  },
  CUSTOMER: {
    LISTING: 'customer/get-all-customer',
    BY_ID: 'customer/get-customer-by-id',
    ADD: 'customer/add-customer',
    UPDATE: 'customer/update-customer',
    APPLICATIONS: 'customer/applications',
    ADD_CONFIG: 'customer/config',
    GET_CONFIG: 'customer/config',
    ASSETS: {
      LISTING: 'admin/getUserAssetById/',
      BY_LOCATION: 'asset/get-assets-by-location',
      ADD_EXCEL: 'asset/addAssetWithExcel',
      ADD: 'asset/add-assets_v2',
      UPDATE: 'asset/update-asset_v2',
      DELETE: 'admin/deleteAssetById'
    },
    GATEWAY: {
      LISTING: 'admin/getUserGatewayById/',
      BY_CUSTOMER: 'gateway/get-gateway',
      GET_SERIAL_NO: 'gateway/get-gateway-serial-no',
      ADD: 'gateway/add-gateway',
      EXCEL: 'gateway/add-gateway-excel',
      UPDATE: 'gateway/update-gateway',
      DELETE: 'admin/deleteGatewayById'
    },
    SENSOR: {
      LISTING: 'admin/getSensorsById/',
      // UNASSIGNED: 'admin/getWhitelisitingData',
      UNASSIGNED: 'admin/getUnmappedSensors',
      ADD: 'sensor/add-sensor_v2',
      UPDATE: 'sensor/update-sensor_v2',
      EXCEL: 'sensor/add-sensor-xcel',
      ADD_BULK_DEVICE: 'sensor/add-bulk-device',
      DELETE: 'admin/deleteSensorById',
      TRANSPORT: {
        ADD_INVENTORY: 'sensor/transport/inventory/add-sensor',
        GET_INVENTORY: 'sensor//transport/inventory/get-sensors',
        UPDATE_INVENTORY: 'sensor/transport/inventory/update-sensor',
        DELETE_INVENTORY: 'sensor/transport/inventory/delete-sensor',
        EXCEL: 'sensor/transport/inventory/add-excel'
      }
    },
    HOOTER: {
      LISTING: 'admin/hooterbyUserId/',
      GET_MODEL_NO: 'model-master/get-hooter-modelno',
      ADD: 'hooter/add-hooter',
      EXCEL: 'hooter/add-hooter-xcel',
      UPDATE: 'hooter/update-hooter',
      DELETE: 'admin/deleteHooterById'
    },
    ASSET_SENSOR_MAPPING: {
      LISTING: 'admin/getCustomerAssetSensorMapingById/',
      ADD_EXCEL: 'admin/add-sensor-map-by-excel',
      DELETE: 'admin/deleteMapping'
    },
    USER: {
      LISTING: 'user/get-all-users',
      BY_ID: 'user/get-user',
      ADD_EXCEL: 'user/add-user-by-excel',
      ADD: 'user/add-user',
      UPDATE: 'user/update-user',
      DELETE: 'user/delete-user',
      LOCATION_ACCESS: 'admin/getLocationCheckForUser/',
      UPDATE_LOCATIONS: 'user/update-user',
      GET_ROLES: 'user/get-roles',
      ADD_ROLE: 'user/add-user-role',
      RESET_PASSWORD: 'admin/reset-password'
    },
    LOCATION: {
      GET_LOCATION: 'customer/get-location',
      BY_GROUP_ID: 'groupzone/getNlevelByUserId',
      ADD_LOCATION: 'customer/add-location',
      UPDATE_LOCATION: 'customer/update-location'
    },
    REPORT: {
      GET_COUNT: 'asset/get-missing-count',
      GET_MISSING_TIMESTAMP: 'asset/get-missing-timestamp',
      DATA_PATCHING: 'data-recall/data-patch',
      DATA_RECALL: 'data-recall/data-recall',
    },
    MASTER: {
      ROLES: 'role/get-roles-by-customer-id',
      GET_ENV_BY_CUSTOMER: 'customer/environment',
      EXCURSION: 'customer/excursion',
      CAPABILITY: 'capabilities'
    },
  },
  CERTIFICATE: {
    LISTING: 'admin/getAllCertificates',
    ADD: 'admin/upload-sensor-ceritficate',
    UPDATE: 'admin/update-sensor-ceritficate',
    GET_ACTIVE_EXTERNAL_SENSORS: 'admin/getAvailableInventory',
    BULK_UPLOAD: 'upload-bulk-certificate',
  },
  WHITELIST: {
    SENSORS: 'admin/getUnmappedSensors',
    GATEWAYS: 'admin/getUnmappedGateway',
    EXTERNAL_SENSORS: 'admin/getUnmappedExternal-sensor',
    HOOTERS: 'admin/getUnmaphooter'
  },
  DEVICE_MANAGEMENT: {
    SENSORS: {
      GET_ALL_DEVICES: 'admin/getWhitelisitingData',
      CHANGE_STATUS: 'admin/changeStatusSensorWhiteLisiting',
      ADD_EXCEL: 'admin/add_whiteLisiting_sensors_By_excel',
      REQUEST_EXTERNAL_SENSOR: 'request-external-sensor-data'
    },
    GATEWAYS: {
      GET_ALL_DEVICES: 'admin/get_whiteLisiting_Gateway',
      CHANGE_STATUS: 'admin/changeStatusGateway',
      ADD_EXCEL: 'admin/addwhiteLisiting_gateway'
    },
    EXTERNAL_SENSORS: {
      GET_ALL_DEVICES: 'admin/getAllExternalSensor',
      CHANGE_STATUS: 'admin/changeStatusOfExternalSensor',
      ADD_EXCEL: 'admin/uploadExternalSensorSrNoWithExcel'
    },
    HOOTERS: {
      GET_ALL_DEVICES: 'admin/getWhitelisitingHooterData',
      CHANGE_STATUS: 'admin/changeStatusHooterWhiteListing',
      ADD_EXCEL: 'admin/add_whiteLisiting_hooter_By_excel'
    }
  },
  MASTER_MANAGEMENT: {
    ROLES: {
      GET_BY_CUSTOMER_ID: 'user/get-roles',
      ADD: 'user/add-role',
      DELETE: 'role/delete-role',
      UPDATE: 'user/update-role'
    },
    TEMPLATES: {
      GET: 'templates/get-templates',
      CREATE: 'templates/create-template',
      UPDATE: 'templates/update-template/:id',
      DELETE: 'model-master/delete-communication-template'
    },
    ENVIRONMENTS: {
      GET_BY_CUSTOMER_ID: 'customer/environment',
      ADD: 'customer/environment',
      DELETE: 'customer/environment',
      UPDATE: 'customer/environment'
    },
    EXCURSIONS: {
      GET_BY_CUSTOMER_ID: 'customer/excursion',
      ADD: 'customer/excursion',
      DELETE: 'customer/excursion',
      UPDATE: 'customer/excursion'
    },
    CAPABILITIES: {
      GET: 'customer/master-capabilities',
      ADD: 'customer/master-capabilities',
      DELETE: 'model-master/delete-capability',
      UPDATE: 'customer/master-capabilities'
    },
    COMMUNICATION: {
      GET_ALL_TEMPLATES: 'model-master/get-communication-template',
      CREATE: 'model-master/add-communication-template',
      UPDATE: 'model-master/update-communication-template',
    },
    MODEL: {
      ADD_MODEL_NO: 'model-master/add-model-data',
      GET_MODEL_NO: 'admin/getActiveModelNumber',
      GET_SENSOR_BY_MODEL_NO: 'admin/getActiveSerialNoLinkedWithModelNumber'
    },
    ABBREVIATIONS: {
      GET_BY_CUSTOMER_ID: 'customer/abbreviations',
      ADD: 'customer/abbreviations',
      UPDATE: 'customer/abbreviations',
      DELETE: 'customer/abbreviations',
      VALIDATE: 'customer/abbreviations/validate'
    },
    FEATURES: {
      GET: 'admin/get-all-features',
      ADD: 'admin/add-feature'
    }
  },
  PROFILE: {
    USER_PROFILE: 'user/get-user-by-id',
  }
}
